<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-live_box" v-if="templateType == 0">
      <div v-if="livemode" class="dft-live_label">
        <div class="dft-live_label_l">
          <i class="el-icon-s-data"></i>直播中
        </div>
        <div class="dft-live_label_r">
          1.2万人观看
        </div>
      </div>
      <ul class="ul_class" :style="imgbox_Style">
        <li v-for="(item,index) in imgList" :key="index" :style="image_border_Style">
          <el-image v-if="item.img" class="img_class" :style="image_Style1" :src="item.img" :fit="fit"></el-image>
        </li>
      </ul>
    </div>
    <div class="" v-if="templateType == 1" :style="imgbox_Style">
      <el-carousel trigger="click" arrow="never" height="150px" :interval="5000" :style="image_border_Style">
        <el-carousel-item v-for="(item,index) in imgList" :key="index">
          <el-image v-if="item.img" class="img_class" :style="image_Style2" :src="item.img" :fit="fit"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
        type: Array,
        default: ()=>[]
    },
  },
  data () {
    return {
      showDialog: false,
    };
  },
  watch:{
    compData: {
      handler: function(newVal){
        if(newVal){
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          });
          
        }
      },
      deep: true
    }
  },
  computed: {
    //数据
    templateType() {// 0 一行一个 1 轮播海报
      return this.compData[0]?.value
    },
    imgList() {
      return this.compData[1]?.value
    },
    fit() {
      return this.compData[6]?.value
    },
    // 直播模式 1是2否
    livemode() {
      return this.compData[7]?.value == '1'
    },
    // 样式
    container_Style() {
      return {
        [this.compData[4]?.key]: '0 '+this.compData[4]?.value+'px',
      }
    },
    imgbox_Style() {
      return {
        padding: this.compData[2]?.value == '2'?'15px 0':'0',
      }
    },
    image_border_Style() {
      return {
        "box-shadow": this.compData[2]?.value == '2'?'0 4px 10px rgba(47, 54, 70, .1)':'none',
      }
    },
    image_Style1() {
      return {
        [this.compData[3]?.key]: this.compData[3]?.value,
        [this.compData[5]?.key]: this.compData[5]?.value + 'px',
      }
    },
    image_Style2() {
      return {
        [this.compData[3]?.key]: this.compData[3]?.value,
      }
    },
    checkMore() {
      return this.compData[11]?.value == '1'
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  box-sizing: border-box;
}
.ul_class{
  margin: 0;
  &>li:first-of-type .img_class{
    margin-top: 0!important;
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
.dft-live_box{
  position: relative;
}
.dft-live_label{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 140px;
  height: 20px;
  display: flex;
  align-items: center;
  .dft-live_label_l{
    font-size: 11px;
    width: 50%;
    height: 100%;
    padding: 0 5px;
    text-align: center;
    background: #f83403;
    color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dft-live_label_r{
    font-size: 10px;
    width: 50%;
    height: 100%;
    padding: 0 5px;
    background: rgba(0,0,0,0.4);
    color: #fff;
    display: flex;
    align-items: center;
  }
}
</style>

